/** The value from `values` that matches `value`, ignoring case and spaces;
 *  null when none does. For the creators API's enum strings. */
export function normalizeEnum<T extends string>(
	value: string | undefined,
	values: readonly T[],
): T | null {
	const normalized = value?.trim();
	return (
		values.find((item) => item.toUpperCase() === normalized?.toUpperCase()) ??
		null
	);
}

export function normalizeText(value?: string): string {
	return value?.trim() ?? '';
}
